import { ReactNode } from 'react';

type ConditionalWrapperPropsType = {
    condition: boolean;
    wrapper: (children: ReactNode) => ReactNode;
    children: ReactNode;
};

function ConditionalWrapper({ condition, wrapper, children }: ConditionalWrapperPropsType) {
    return condition ? wrapper(children) : <>{children}</>;
}

export default ConditionalWrapper;
